import "../Tweets.css";

//react
import { useEffect, useState } from "react";

//components
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";

//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";


export default function MediaRetorno({ selectedCountry, countryName, countries, countryOptions, setImg1, setImg2 }) {
    //language
    const { language } = useCurrentLanguage();

    //useState - data
    const [data, setData] = useState([]);

    //useState - data2
    const [data2, setData2] = useState([]);

    const [genero, setGenero] = useState([]);

    const [xeno, setXeno] = useState([]);

    //useState - imgs
    const imgUrl1 = ""
    const [imgUrl2, setImgUrl2] = useState("");


    //useEffect
    useEffect(() => {
        if(selectedCountry !== '' && countries.length > 0) processData(["NAC"])
        console.log(data)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCountry, countries])

    //useEffect - imgs
    useEffect(() => {
        setImg1(imgUrl1)
        setImg2(imgUrl2)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imgUrl1, imgUrl2])



    //process data
    const processData = async (selectedCountries) => {
        let df1 = await getCsvData(`/data/retorno/volumen.csv`);

        let df1_genero = await getCsvData(`/data/retorno/volumen_genero_3m.csv`);
        let df1_xeno = await getCsvData(`/data/retorno/volumen_xenofobo_3m.csv`);


        let df_lac = await getCsvData(`/data/retorno/volumen.csv`);
        let df_countries = await getCsvData(`/data/retorno/volumen.csv`);
        
        //drop last item in df1
        df1.pop();
        df_lac.pop();
        df_countries.pop();

        // Filter country
        if (selectedCountry !== 'NAC') {
            alert(selectedCountry)
            df1 = df1.filter(row => row.country === selectedCountry);
            df1_genero = df1_genero.filter(row => row.country === selectedCountry);
            df1_xeno = df1_xeno.filter(row => row.country === selectedCountry);
        } 
        
        //filter LAC
        let tempDf1 = [];
        let tempDates = [];
        df_lac.forEach((e) => {
            if (!tempDates.includes(e.date)) {
                tempDates.push(e.date);
                tempDf1.push(e);
            } else {
                let index = tempDates.indexOf(e.date);
                tempDf1[index].volumen = (parseFloat(tempDf1[index].volumen) + parseFloat(e.volumen)) / 2;
            }
        });
        df_lac = tempDf1;
        

        let dates = []
        let values = []
        let values_lac = []
        let values_country1 = []
        let values_country2 = []
        let values_country3 = []

        if(selectedCountry === 'NAC') {
            df1 = df_lac;

            //filter countries
            let df_country1 = selectedCountries.length >= 2 ? [...df_countries].filter(row => row.country === selectedCountries[1]) || [] : [];
            let df_country2 = selectedCountries.length >= 3 ? [...df_countries].filter(row => row.country === selectedCountries[2]) || [] : [];
            let df_country3 = selectedCountries.length >= 4 ? [...df_countries].filter(row => row.country === selectedCountries[3]) || [] : [];
            

            df_country1.forEach((e) => { values_country1.push(parseFloat(e.volumen)) })
            df_country2.forEach((e) => { values_country2.push(parseFloat(e.volumen)) })
            df_country3.forEach((e) => { values_country3.push(parseFloat(e.volumen)) })
        }

        // Update date to trimester
        df1.forEach(row => {
            dates.push(formatTrimesterLabel(row.date, language));
            values.push(parseFloat(row.volumen));
        });

          let dates_genero = []
        let values_genero = []

        df1_genero.forEach(row => {
            
            dates_genero.push(formatTrimesterLabel(row.date, language));
            values_genero.push(parseFloat(row.Genero));
        });

               let dates_xeno = []
        let values_xeno = []

        df1_xeno.forEach(row => {
            console.log(row)
            dates_xeno.push(formatTrimesterLabel(row.date, language));
            values_xeno.push(parseFloat(row.Xenofobo));
        });

        if(selectedCountry !== 'NAC') {
            df_lac.forEach((e) => { values_lac.push(parseFloat(e.volumen)) })
        }

        let combinedArray = [dates, values];
        let combinedArray2 = [];

         if(selectedCountry !== 'NAC') {
            combinedArray2 = [dates, values, values_lac]
        } else {
            combinedArray2 = [dates, values]
            //push countries if length > 0
            if(selectedCountries.length >= 2) combinedArray2.push(values_country1)
            if(selectedCountries.length >= 3) combinedArray2.push(values_country2)
            if(selectedCountries.length >= 4) combinedArray2.push(values_country3)
        }


        let seriesName = []
        let lac = language === 'es' ? "NCA" : "NAC"
        if (selectedCountry !== 'NAC') {
            seriesName = [countryName, lac]
        } else {
            seriesName = [lac]

            if(selectedCountries.length >= 2) {
                let tempCountry1 = countryOptions.find(e => e.code === selectedCountries[1])
                seriesName.push(language === 'es' ? tempCountry1.country_text : tempCountry1.country_text_en)
            }
            if(selectedCountries.length >= 3) {
                let tempCountry2 = countryOptions.find(e => e.code === selectedCountries[2])
                seriesName.push(language === 'es' ? tempCountry2.country_text : tempCountry2.country_text_en)
            }
            if(selectedCountries.length >= 4) {
                let tempCountry3 = countryOptions.find(e => e.code === selectedCountries[3])
                seriesName.push(language === 'es' ? tempCountry3.country_text : tempCountry3.country_text_en)
            }
        }

        let temp = [
            {
                id: "q2",
                data: combinedArray,
                rotate: false,
                graphType: "bar",
                hasOptions: false,
                isPercentage: true,
                barLegend: language === 'es' ? "Porcentaje" : "Percentage",
                updateTotrimester: false,
            },
        ];

        console.log(selectedCountries)
        console.log(countries)
        let temp2 = [
            {
                id: "q2",
                data: combinedArray2,
                rotate: false,
                graphType: "line",
                hasOptions: false,
                isPercentage: true,
                barLegend: language === 'es' ? "Porcentaje" : "Percentage",
                updateTotrimester: false,
                seriesName: seriesName,
                hasCountries: selectedCountry === 'NAC' ? true : false,
                countryOptions: countries,
                selectedCountries: selectedCountries,
                useColors: false
            },
        ];

        console.log([dates_genero, values_genero])
        let temp_genero = [
            {
                id: "q2",
                data: [dates_genero, values_genero],
                rotate: false,
                graphType: "line",
                hasOptions: false,
                isPercentage: true,
                barLegend: language === 'es' ? "Porcentajess" : "Percentagess",
                updateTotrimester: false,
                seriesName: seriesName,
                hasCountries: true,//selectedCountry === 'NAC' ? true : false,
                countryOptions: [], //countries,
                selectedCountries: ['Mexico','El Salvador','Honduras','Guatemala'],
                useColors: false
            },
        ];

        console.log(dates_xeno)

        let temp_xeno = [
            {
                id: "q2",
                data: [dates_xeno, values_xeno],
                rotate: false,
                graphType: "line",
                isPercentage: true,
                barLegend: language === 'es' ? "Porcentajess" : "Percentagess",
                updateTotrimester: false,
                seriesName: seriesName,
                hasCountries: true,//selectedCountry === 'NAC' ? true : false,
                hasOptions: false,
                countryOptions: [], //countries,
                selectedCountries: ['Mexico','El Salvador','Honduras','Guatemala'],
                useColors: false
            },
        ];

        setGenero(temp_genero);
        setXeno(temp_xeno);
        setData(temp);
        setData2(temp2);
    };

    //handle countries change
    const handleCountriesChange = (countries) => {
        processData(countries)
    }


    return (
        <div className="surveys-page-content">
            <div className="surveys-page-graphs">
                <div className="survey-page-full-surveys">
                    <div className="full-screen">
                        <div className="nl-selector-container">
                        </div>
                        <div>
                            <TweetGraph data={data2} title={TEXT['volume']['volume_ret']['title'][language]} setImgUrl={setImgUrl2} onCountriesChange={handleCountriesChange}/>
                        </div>
                        <div>
                            <TweetGraph data={genero} title={TEXT['volume']['volume_ret']['title'][language]} setImgUrl={setImgUrl2} onCountriesChange={handleCountriesChange}/>
                        </div>
                        <div>
                            <TweetGraph data={xeno} title={TEXT['volume']['volume_ret']['title'][language]} setImgUrl={setImgUrl2} onCountriesChange={handleCountriesChange}/>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
  );
}